import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { FaTachometerAlt, FaCar, FaExchangeAlt } from 'react-icons/fa'

const navItems = [
   { path: '/mobile/dashboard', label: 'Dashboard', icon: FaTachometerAlt, color: 'bg-blue-500' },
   { path: '/mobile/myTrips', label: 'Mine turer', icon: FaCar, color: 'bg-green-500' },
   { path: '/mobile/shifts', label: 'Mine skift', icon: FaExchangeAlt, color: 'bg-green-500' }
]

const BottomNav = () => {
   const history = useHistory()
   const location = useLocation()

   return (
      <div className="flex-shrink-0 bg-white border-t border-gray-200 flex justify-around items-center py-2 z-20">
         {navItems.map(({ path, label, icon: Icon, color }) => {
            const isActive = location.pathname === path
            return (
               <button
                  key={path}
                  onClick={() => history.push(path)}
                  className="flex flex-col items-center flex-1 focus:outline-none">
                  <span
                     className={`flex items-center justify-center w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 rounded-full text-white ${color} ${
                        isActive ? 'opacity-100' : 'opacity-60'
                     }`}>
                     <Icon className="text-base md:text-xl lg:text-2xl" />
                  </span>
                  <span
                     className={`text-xs md:text-sm lg:text-base mt-1 ${
                        isActive ? 'text-gray-900 font-semibold' : 'text-gray-500'
                     }`}>
                     {label}
                  </span>
               </button>
            )
         })}
      </div>
   )
}

export default BottomNav
